import React, { Component } from "react";

class ImageLoading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      img: this.props.altImg
    };
    this.didStartLoading = false;
    this.src = this.props.src;
    this.setContentData = this.setContentData.bind(this);
  }

  setContentData() {
    if (this.didStartLoading === false) {
      if (
        this.src !== "" &&
        this.src !== undefined &&
        this.state.img !== this.src
      ) {
        this.didStartLoading = true;
        const objImg = new Image();
        objImg.src = this.src;
        objImg.onload = () => {
          this.setState({ img: this.src });
        };
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    this.src = nextProps.src;
    this.setContentData();
  }

  render() {
    return (
      <div
        className={this.props.className}
        style={{
          backgroundImage: "url(" + this.state.img + ")",
          backgroundSize: "cover",
          backgroundColor: this.props.backgroundColor || "#D02563",
          ...this.props.style
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

export default ImageLoading;
